export const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  addButton: {
    marginTop: theme.spacing.unit * 2
  }
})


// WEBPACK FOOTER //
// ./src/components/AddWaitingPassengerForm/styles.js